import { request } from "./request";

export interface CompanyProfileData {
  business_activity: string;
  company_name: string;
  legal_form: string;
  legal_form_other?: string;
  industry_sector: string[] | string;
  industry_sector_other?: string;
  nip: string;
  /** pirx-lus53: declared certificate schemes (multi-cert array or legacy scalar). */
  declared_certificate?: string[] | string;
  /** pirx-waua: free-text when declared_certificate includes "other". */
  declared_certificate_other?: string;
}

export interface UserProfile {
  id: string;
  email: string;
  name?: string;
  avatarUrl?: string;
  onboardingCompleted?: boolean;
  companyData?: CompanyProfileData | null;
  teams?: Array<{
    id: string;
    name: string;
    role: "owner" | "admin" | "member";
    isPersonal?: boolean;
  }>;
  appLanguage?: "pl" | "en";
  reportLanguage?: "pl" | "en";
  /** Per-user default target market that pre-fills the audit form. */
  defaultMarket?: string;
}

export async function getUserProfile(): Promise<UserProfile> {
  return request<UserProfile>("/auth/me");
}

export async function updateUserPreferences(
  preferences: {
    app_language?: "pl" | "en";
    report_language?: "pl" | "en";
    default_market?: string;
  },
): Promise<UserProfile> {
  const response = await request<{ user: UserProfile }>("/users/preferences", {
    method: "PUT",
    body: preferences,
    contentType: "json",
  });
  return response.user;
}

export async function updateUserProfile(
  data: CompanyProfileData,
): Promise<UserProfile> {
  const response = await request<{ user: UserProfile }>("/users/profile", {
    method: "PUT",
    body: data as unknown as Record<string, unknown>,
    contentType: "json",
  });
  return response.user;
}

export interface OnboardingCompanyData {
  businessActivity: string;
  companyName: string;
  legalForm: string;
  legalFormOther?: string;
  industrySector: string[];
  industrySectorOther?: string;
  nip: string;
  /** pirx-lus53: declared certificate schemes (camelCase, multi-select). */
  declaredCertificate?: string[];
  /** pirx-waua: free-text when declaredCertificate includes "other". */
  declaredCertificateOther?: string;
}

export async function submitOnboarding(
  data: OnboardingCompanyData,
): Promise<UserProfile> {
  return request<UserProfile>("/users/onboarding", {
    method: "POST",
    body: data as unknown as Record<string, unknown>,
    contentType: "json",
  });
}
